module.exports = __webpack_public_path__ + "img/65.28ec8abe.webp";